<div class="container">
    <object type="image/svg+xml" data="/assets/Zaver_Pageloader_Dots.svg">
    </object>
</div>